export const getKaMetlhaFuneralCover = (state) =>
  state.kaMetlhaFuneralCover;
